var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1769245696069,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 32852,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M787.2 512l204.8 172.8-64 70.4-89.6-76.8 6.4 230.4h-96l-6.4-224-89.6 89.6L582.4 704l204.8-192zM633.6 76.8c211.2 0 390.4 160 390.4 358.4 0 25.6-19.2 51.2-51.2 51.2-25.6 0-51.2-19.2-51.2-51.2 0-147.2-128-262.4-294.4-262.4-160 0-294.4 121.6-294.4 262.4 0 25.6-19.2 51.2-51.2 51.2C198.4 486.4 128 556.8 128 646.4c0 83.2 70.4 153.6 153.6 160h12.8l268.8 6.4c25.6 0 44.8 25.6 44.8 51.2s-19.2 44.8-44.8 44.8h-6.4l-268.8-6.4c-147.2 0-262.4-115.2-262.4-256 0-128 96-230.4 217.6-249.6 25.6-179.2 192-320 390.4-320z",
    fill: "#2c2c2c",
    "p-id": 32853
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a3b128b0181221c1c3df8556a44b4d01.svg";
export { ForwardRef as ReactComponent };